import { gql } from '@apollo/client';
const REMOVE_PRODUCT_CONTINENT = gql `
  mutation RemoveProductContinent($productContinentId: ID!) {
    removeProductContinent(productContinentId: $productContinentId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT_CONTINENT;
